import sendToServer from "./send-to-server";
import trackEvent from "./track-event";
import Answers from "./answers";
import KeyTerms from "./key-terms";

const CareerQuizFunctionality = {
  init() {
    if (!($(".career-quiz").length > 0)) return;

    KeyTerms.init();

    $(".like-button").click(this.handleLikeClick.bind(this));
    $(".dislike-button").click(this.handleDislikeClick.bind(this));
    $(".confirm-enjoyment").click(this.handleConfirmEnjoymentClick.bind(this));
    $(".qualitative-button").click(
      this.handleQualitativeButtonClick.bind(this)
    );
    $(".explainer-overlay").click(this.handleOverlayClick.bind(this));
    $(".next-button").click(this.handleNextButtonClick.bind(this));
    $(".quit-button").click(this.handleQuitButtonClick.bind(this));
    $(".quit-box .cancel").click(this.handleCancelQuitClick.bind(this));
    $(".quit-choice").click(this.handleQuitChoiceClick.bind(this));
    $(".popup .closer").click(this.handleClosePopupClick.bind(this));
    $(".enjoyment-reason-button").click(
      this.handleEnjoymentReasonSubmission.bind(this)
    );
    $(".reasoning-text").keyup(this.onReasoningTyping.bind(this));

    this.preventSubmission = $(".question").data("collect-reasoning");

    this.answerFunctionality = Answers.init(this, KeyTerms);
  },

  handleLikeClick() {
    this.handleEmotionChoice(true, { enjoyment_level: 4 });
  },

  handleDislikeClick() {
    this.handleEmotionChoice(false, { enjoyment_level: 2 });
  },

  handleQualitativeButtonClick(event) {
    const $button = $(event.target).closest(".qualitative-button");
    const enjoyment = $button.data("enjoyment-level");
    this.handleEmotionChoice(enjoyment > 3, {
      quality: $button.data("quality"),
      enjoyment_level: enjoyment,
    });
  },

  handleConfirmEnjoymentClick() {
    this.enjoymentLevel = $("#enjoyment-slider").val();
    trackEvent("EnjoymentRating", this.enjoymentLevel + "/5");
    this.handleEmotionChoice(this.enjoymentLevel > 3, {
      enjoyment_level: this.enjoymentLevel,
    });
  },

  handleEmotionChoice(liked, options) {
    if (!options) options = {};
    const data = $.extend({ liked: liked }, options);
    trackEvent(
      "Question",
      liked ? "liked" : "disliked",
      $(".question").data("question-id")
    );
    sendToServer(
      "/api/v2/question_relationships/" + $(".question").data("question-id"),
      data,
      null,
      "PATCH"
    );
    $(".like-box .content").fadeOut(300, this.afterEmotionChoice.bind(this));
    $(".question").data("recorded-emotion", true);
  },

  afterEmotionChoice() {
    $(".like-box").removeClass("displaying");

    const collect =
      ($(".question").data("collect-extreme-enjoyment-reason") &&
        (this.enjoymentLevel == 1 || this.enjoymentLevel == 5)) ||
      ($(".question").data("collect-moderate-enjoyment-reason") &&
        (this.enjoymentLevel == 2 || this.enjoymentLevel == 4));
    if (collect) {
      if (this.enjoymentLevel > 3) {
        $(".enjoyment-reason-prompt").html(
          $(".enjoyment-reason-prompt").data("positive-prompt")
        );
      } else {
        $(".enjoyment-reason-prompt").html(
          $(".enjoyment-reason-prompt").data("negative-prompt")
        );
      }

      $(".enjoyment-reason-box").addClass("displaying");
    } else {
      this.onEmotionCompletion();
    }
  },

  handleEnjoymentReasonSubmission() {
    const reasonGiven = $(".enjoyment-reason-field").val();
    if (reasonGiven.length === 0) return;

    sendToServer(
      "/api/v2/question_relationships/" + $(".question").data("question-id"),
      { enjoyment_reason: reasonGiven },
      null,
      "PATCH"
    );

    $(".enjoyment-reason-box").removeClass("displaying");
    this.onEmotionCompletion();
  },

  goToNextPath() {
    $(".next-panel").slideUp(300);
    $(".question-box").slideUp(300, () => {
      window.location = $(".next-panel").data("next-path");
    });
  },

  handleOverlayClick() {
    $(".explainer-overlay").fadeOut();
  },

  handleNextButtonClick() {
    this.showEmotionPanel(this.goToNextPath);
  },

  onAnswerSubmission(postAnswerSubmission) {
    if ($(".question").data("collect-reasoning")) {
      this.submitReasoning(postAnswerSubmission);
    } else {
      this.showEmotionPanel(postAnswerSubmission);
    }
  },

  showEmotionPanel(onCompletion) {
    if (
      $(".question").data("recorded-emotion") ||
      $(".question").data("skip-enjoyment")
    ) {
      onCompletion();
    } else {
      this.onEmotionCompletion = onCompletion;
      $(".like-box").addClass("displaying");
    }
  },

  onReasoningTyping() {
    const text = $(".reasoning-text").val().trim();

    if (text.length < 1) {
      this.preventSubmission = true;
    } else {
      this.preventSubmission = false;
    }

    this.answerFunctionality.showConfirmSelectionPanelIfAppropriate();
  },

  submitReasoning(postAnswerSubmission) {
    const text = $(".reasoning-text").val().trim();

    if (text.length < 1) return;

    sendToServer(
      "/api/v2/question_relationships/" + $(".question").data("question-id"),
      { reasoning: text },
      () => {
        this.showEmotionPanel(postAnswerSubmission);
      },
      "PATCH"
    );

    $(".reasoning-panel").hide();
  },

  handleQuitButtonClick() {
    if (
      $(".question").data("quit-questionnaire") &&
      !$(".question").data("pre-answered")
    ) {
      $(".quit-box").addClass("displaying");
    } else if ($(".question").data("quit-to-rate")) {
      window.location = `/app/careers/${$(".question").data("career-id")}/rate`;
    } else {
      window.location = "/app";
    }
  },

  handleCancelQuitClick() {
    $(".quit-box").removeClass("displaying");
  },

  handleQuitChoiceClick(event) {
    const $button = $(event.target).closest(".quit-choice");
    sendToServer("/api/v2/events", {
      event: "quit_" + $button.data("reason") + "_career",
      career_id: $(".question").data("career-id"),
      question_id: $(".question").data("question-id"),
    });

    if (
      $(".question").data("quit-to-main-site") &&
      $button.data("reason") !== "unspecifiedly_bad"
    ) {
      window.location = "https://thinksmart.careers/app";
    } else {
      window.location = "/app";
    }
  },

  handleClosePopupClick() {
    $(".popup").hide();
  },
};

$(document).ready(() => {
  CareerQuizFunctionality.init();
});
